import React from "react";

import Page from "../../components/Page";
import GradesList from "../../components/sections/grade/GradesList";

const Grades = () => {
  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "",
      breadcrumbName: "Grades",
    },
  ];
  return (
    <>
      <Page title="Grades" breadcrumb={breadcrumb}>
        <GradesList />
      </Page>
    </>
  );
};

export default Grades;
